// PreTravelContent layout

import React from "react";
import { connect } from "react-redux";

import {
  toggleIndicator,
  updateComment
} from "@pretravel/components/App/action";
import { updateStep } from "@pretravel/components/Sidebar/action";

import { Text } from "ui-components";
import { RiskList } from "./riskList";
import Comment from "@common/components/Comment";
import AppendixDialog from "@common/components/AppendixDialog";
import RiskSectionInfo from "@common/components/RiskSectionInfo";

import {
  toggleAppendixTip,
  toggleSuggestedTip,
  upsertSuggestedTip,
  deleteSuggestedTip
} from "@pretravel/components/App/action";

import { RiskListHeader } from "@common/styled/risk";
import { LayoutWrapper, LayoutHeader, LayoutBody } from "@common/styled/layout";

class RisksLayout extends React.Component {
  render() {
    const {
      activeSubStep,
      section,
      toggleIndicator,
      updateComment
    } = this.props;

    // Sub section
    const currentSubsection = section.subsections[activeSubStep];
    const risks = currentSubsection.risks;
    const commentValue = currentSubsection.comment
      ? currentSubsection.comment
      : "";

    return (
      <LayoutWrapper>
        <LayoutHeader>
          <Text size={4} type="bold">
            Assessment Item
          </Text>
          <Text size={5}>
            (Checklist to be completed by supervisor before the worker conducts the initial home visit)
          </Text>
        </LayoutHeader>
        <LayoutBody>
          <RiskListHeader>
            Risk Identification
          </RiskListHeader>
          {RiskList(risks, activeSubStep, toggleIndicator)}
          <RiskSectionInfo
            suggestedTips={currentSubsection.suggestedTips}
            checkedAppendixTips={currentSubsection.checkedAppendixTips}
          />
          <Comment
            onBlur={e => updateComment(e.target.value, activeSubStep)}
            value={commentValue}
          />
          <AppendixDialog
            subsectionIdx={activeSubStep}
            isShown={this.props.isAppendixDialogShown}
            toggleDialog={this.props.hideAppendixDialog}
            section={currentSubsection}
            onAppendixTipClick={this.props.toggleAppendixTip}
            onSuggestedTipClick={this.props.onSuggestedTipClick}
            upsertSuggestedTip={this.props.upsertSuggestedTip}
            deleteSuggestedTip={this.props.deleteSuggestedTip}
          />
        </LayoutBody>
      </LayoutWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    toggleIndicator: (activeSubStep, riskIndex) =>
      dispatch(toggleIndicator(activeSubStep, riskIndex)),
    updateStep: args => dispatch(updateStep(args)),
    updateComment: (comment, activeSubStep) =>
      dispatch(updateComment(comment, activeSubStep)),
    toggleAppendixTip: tipInfo => dispatch(toggleAppendixTip(tipInfo)),
    onSuggestedTipClick: tipInfo => dispatch(toggleSuggestedTip(tipInfo)),
    upsertSuggestedTip: tipInfo => dispatch(upsertSuggestedTip(tipInfo)),
    deleteSuggestedTip: tipInfo => dispatch(deleteSuggestedTip(tipInfo))
  };
}

export default connect(null, mapDispatchToProps)(RisksLayout);



// WEBPACK FOOTER //
// ./src/pretravel/components/Content/Risks/risksLayout.jsx